/**
 * Convert a number to Romanian text (uppercase).
 * Supports integers from 0 to 999,999,999.
 */

const UNITS = ["", "unu", "doi", "trei", "patru", "cinci", "sase", "sapte", "opt", "noua"];
const UNITS_FEM = ["", "una", "doua", "trei", "patru", "cinci", "sase", "sapte", "opt", "noua"];
const TEENS = [
  "zece", "unsprezece", "doisprezece", "treisprezece",
  "paisprezece", "cincisprezece", "saisprezece",
  "saptesprezece", "optsprezece", "nouasprezece"
];
const TENS = [
  "", "zece", "douazeci", "treizeci", "patruzeci",
  "cincizeci", "saizeci", "saptezeci", "optzeci", "nouazeci"
];

function hundreds(n) {
  if (n === 0) return "";
  const parts = [];
  const h = Math.floor(n / 100);
  const rest = n % 100;

  if (h === 1) parts.push("o suta");
  else if (h === 2) parts.push("doua sute");
  else if (h > 2) parts.push(`${UNITS[h]} sute`);

  if (rest === 0) {
    // nothing
  } else if (rest < 10) {
    parts.push(rest <= 2 ? UNITS_FEM[rest] : UNITS[rest]);
  } else if (rest < 20) {
    parts.push(TEENS[rest - 10]);
  } else {
    const t = Math.floor(rest / 10);
    const u = rest % 10;
    if (u === 0) {
      parts.push(TENS[t]);
    } else {
      const unitWord = u <= 2 ? UNITS_FEM[u] : UNITS[u];
      parts.push(`${TENS[t]} si ${unitWord}`);
    }
  }

  return parts.join(" ");
}

export function numberToTextRo(num) {
  const n = Math.floor(Math.abs(Number(num) || 0));
  if (n === 0) return "ZERO";

  const parts = [];

  // Millions
  const millions = Math.floor(n / 1000000);
  const remainder1 = n % 1000000;

  if (millions === 1) parts.push("un milion");
  else if (millions === 2) parts.push("doua milioane");
  else if (millions > 2) parts.push(`${hundreds(millions)} milioane`);

  // Thousands
  const thousands = Math.floor(remainder1 / 1000);
  const remainder2 = remainder1 % 1000;

  if (thousands === 1) parts.push("o mie");
  else if (thousands === 2) parts.push("doua mii");
  else if (thousands > 2) parts.push(`${hundreds(thousands)} mii`);

  // Rest
  if (remainder2 > 0) parts.push(hundreds(remainder2));

  return parts.join(" ").replace(/\s+/g, " ").trim().toUpperCase();
}
